// Generate a unique id or key

let counter = 0;

export default function (prefix = false) {
  counter += 1;
  return prefix ? `${prefix}-${counter}` : counter;
}
